
import AV from "leancloud-storage";
import { Quiz } from "@/models";
import XProgress from 'vux/src/components/x-progress/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

import QuizQuestionItem from "@/components/quiz/quiz_question/QuizQuestionItem.vue";
import FillInfoForQuizDialog from "@/components/common/FillInfoForQuizDialog.vue";
import { mapGetters, mapActions } from "vuex";
import { setInterval, clearInterval } from "timers";

export default {
name: "StartQuiz",
async created() {
let quizId = this.$route.params.id;
this.quizId = quizId;
if (!quizId) {
return;
}

let startImmediately = parseInt(this.$route.query.start) == 1;

this.quiz = await Quiz.getById(quizId);
this.initWechatShare();

try {
let myResult = await Quiz.getMyResult(quizId);
if (myResult && !this.quiz.get("canParticipateMultiTimes")) {
this.$router.push({ name: "quiz", params: { id: quizId } });
return;
}

this.showCover = true;
if (startImmediately) {
this.userCheck();
}
} catch (err) {
this.showCover = true;
if (startImmediately) {
this.userCheck();
}
}
},
props: [],
data() {
return {
quizId: null,
quiz: null,
questions: [],
showQuestion: false,
showCover: false,
currentIndex: 0,
timer: null,
percentage: 0,
showFillInfoForQuizDialog: false,
quizResultId: null,
};
},
metaInfo() {
return {
title: this.title,
titleTemplate: null,
};
},
computed: {
...mapGetters(["user", "shouldFillInfo"]),

title: function () {
return (this.quiz ? this.quiz.get("title") : "诗词测验") + " · 西窗烛";
},
currentQuestion: function () {
if (this.currentIndex >= this.questions.length) {
return null;
}

return this.questions[this.currentIndex];
},
},
methods: {
...mapActions(["fetchUser"]),

async userCheck() {
if (!this.user) {
this.$router.push({
name: "logInSelection",
query: { from: this.$route.path + "?start=1" },
});
throw new Error("Sign in first.");
}

await this.fetchUser()

if (this.shouldFillInfo) {
this.showFillInfoForQuizDialog = true
return
}

this.start();
},

async start() {
this.questions = await Quiz.getQuestions(this.quizId);
let result = await Quiz.start(this.quizId);
if (result.started) {
this.$vux.toast.show({
text: result.message,
type: "text",
position: "middle",
})
return
}
this.quizResultId = result.quizResultId;
this.showCover = false;
this.showQuestion = true;
this.createTimer();
},

didBindPhone(phone) {
this.$vux.toast.show({
text: "绑定成功，开始答题",
type: "success",
});
this.start();
},

didFillInfo() {
this.$vux.toast.show({
text: "报名成功，开始答题",
type: "success",
});
this.start();
},

goToRanks: function () {
this.$router.push({ name: "quiz", params: { id: this.quiz.id } });
},

async answer() {
if (this.currentIndex < this.questions.length - 1) {
this.goToNextQuestion();
this.percentage = 0;
} else {
await this.finishQuiz();
}
},

async finishQuiz() {

this.$vux.loading.show({
text: "提交中...",
});

try {
await Quiz.finish(this.quizId, this.quizResultId);
setTimeout(() => {
this.$vux.loading.hide();
this.$router.replace({
name: "myQuizResult",
params: { id: this.quizResultId },
});
}, 2000);
} catch (err) {
this.$vux.loading.show({
text: "提交失败，错误：" + err.toString(),
});
}
},


goToNextQuestion: function () {
this.currentIndex += 1;
this.$vux.toast.show({
text: `第 ${this.currentIndex + 1} 题`,
position: "middle",
time: 1000,
type: "text",
});
},


async skipToNextQuestion() {
if (!this.currentQuestion) {
return;
}

if (this.currentIndex == this.questions.length - 1) {
await this.finishQuiz();
return;
}

try {
await this.currentQuestion.skip(this.quiz.id, this.quizResultId);
this.goToNextQuestion();
} catch (err) {
this.goToNextQuestion();
}
},

createTimer: function () {
clearInterval(this.timer);

this.percentage = 0;

this.timer = setInterval(() => {

this.percentage += (1 / 30) * 100;

if (this.percentage >= 100) {
this.skipToNextQuestion();
this.percentage = 0;
}
}, 1000);
},

initWechatShare() {
this.$initWechat().then(() => {
this.$initWechatShare({
title: this.quiz.get("title") + " · 西窗烛",
link: "http://m.xczim.com/quiz/" + this.quiz.id,
image: this.quiz.get("coverForShare")
? this.quiz.get("coverForShare").url()
: "http://ac-9pq709je.clouddn.com/0aa50e161e586f7fb105.png",
desc: "快来测测你的诗词量吧！",
});
});
},
},

beforeDestroy() {
clearInterval(this.timer);
},

components: {
QuizQuestionItem,
XProgress,
Confirm,
FillInfoForQuizDialog
},
};



// WEBPACK FOOTER //
// ./src/pages/quiz/StartQuiz.vue